export default "__VITE_ASSET__2ce9322c__"